import { FileType } from '@office-start/document-types';
var wacFileTypes = new Set([
    FileType.Word,
    FileType.Excel,
    FileType.PowerPoint,
    FileType.Visio,
]);
export function isWacFileType(fileType) {
    return wacFileTypes.has(fileType);
}
export function canOpenInWac(item) {
    if (!item.fileType ||
        item.isLocalFile ||
        item.isOnPremOrVanity ||
        item.isEmailAttachment) {
        return false;
    }
    return isWacFileType(item.fileType);
}
//# sourceMappingURL=canOpenInWac.js.map